import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { useMe } from './api/hooks.ts';
import { AuthRoot } from './auth/session.tsx';
import { EmptyState } from './components/ui.tsx';
import { Folder } from './icons.ts';
import { Shell } from './layout/Shell.tsx';
import { AgentsPage, MembersPage } from './pages/AgentsPage.tsx';
import { FilesPage } from './pages/FilesPage.tsx';
import { InvitePage } from './pages/InvitePage.tsx';
import { ItemPage } from './pages/ItemPage.tsx';
import { ActivityPage, NotesPage, SearchPage, SitesPage, TrashPage } from './pages/ListPages.tsx';
import { MeetingsPage, VoiceNotesPage } from './pages/RecordingsPages.tsx';
import { SettingsPage } from './pages/SettingsPage.tsx';

function Home() {
  const me = useMe();
  if (me.isError) {
    return (
      <div className="signin">
        <div className="signin-sheet">
          <p>
            <span className="state">Could not reach Mystiq.</span> {(me.error as Error).message}
          </p>
        </div>
      </div>
    );
  }
  const first = me.data?.workspaces[0];
  if (!first) return <div className="signin"><p className="meta">Loading your workspace…</p></div>;
  return <Navigate to={`/w/${first.id}/files`} replace />;
}

export function App() {
  return (
    <AuthRoot>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/w/:workspaceId" element={<Shell />}>
            <Route index element={<Navigate to="files" replace />} />
            <Route path="files" element={<FilesPage />} />
            <Route path="folders/:folderId" element={<FilesPage />} />
            <Route path="notes" element={<NotesPage />} />
            <Route path="voice-notes" element={<VoiceNotesPage />} />
            <Route path="meetings" element={<MeetingsPage />} />
            <Route path="sites" element={<SitesPage />} />
            <Route path="items/:itemId" element={<ItemPage />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="trash" element={<TrashPage />} />
            <Route path="activity" element={<ActivityPage />} />
            <Route path="agents" element={<AgentsPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<EmptyState icon={Folder} title="Page not found" />} />
        </Routes>
      </BrowserRouter>
    </AuthRoot>
  );
}
